// Side-nav

function openNav() {
    document.getElementById("sidebar").classList.add("sidebar-width");
    document.getElementById("sidebar_overlay").style.display = "block";
	document.getElementById("sidenav-header").classList.add("sidebar-width");
	document.getElementById("body").style.overflow = "hidden";
}

function closeNav() {
    document.getElementById("sidebar").classList.remove("sidebar-width");
    document.getElementById("sidebar_overlay").style.display = "none";
	document.getElementById("sidenav-header").classList.remove("sidebar-width");
	document.getElementById("body").style.overflow = "auto";
}

// Accordion

function accordion() {
	let acc = document.getElementsByClassName("accordion");
	let i;
	for (i = 0; i < acc.length; i++) {
		acc[i].addEventListener("click", function() {
			this.classList.toggle("active");
			this.classList.toggle("icon-caret-right");
			this.classList.toggle("icon-caret-down");
			let panel = this.nextElementSibling;
			if (panel.style.maxHeight) {
					panel.style.maxHeight = null;
			} else {
					panel.style.maxHeight = panel.scrollHeight + "px";
			}
		});
	}
}

accordion();